"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyDropletAndAssociatedResources = void 0;
const destroyDropletAndAssociatedResources = ({ httpClient, }) => ({ droplet_id, snapshots, volume_snapshots, volumes, }) => {
    const path = '/droplets';
    const url = `${path}/${droplet_id}/destroy_with_associated_resources/selective`;
    const body = {
        snapshots,
        volume_snapshots,
        volumes,
    };
    return httpClient.delete(url, { data: body });
};
exports.destroyDropletAndAssociatedResources = destroyDropletAndAssociatedResources;
//# sourceMappingURL=destroy-droplet-and-associated-resources.js.map